import React, { useEffect } from "react";
import { Box, Paper } from "@mui/material";
import { tallyFormPanelStyles } from "../PanelStyles";
import { theme } from "../../theme";

// TODO: Rename class and filename from TallyFormPanel to NewSourcesFormPanel,
// kept for now until we have more forms
// Fallback on dev-materiom-ai-sources-tally-form-url if not set, helpful for local development
const MATERIOM_AI_SOURCES_TALLY_FORM_URL =
  process.env.REACT_APP_MATERIOM_AI_SOURCES_TALLY_FORM_URL ||
  "https://tally.so/embed/mYvjEN?&hideTitle=1&transparentBackground=1&dynamicHeight=1";

/**
 * TallyFormPanel Component
 *
 * A panel component that displays an embedded Tally form for collecting user feedback
 * about additional sources for Materiom AI to search from.
 *
 * @component
 * @returns {JSX.Element} Rendered TallyFormPanel component
 */
const TallyFormPanel: React.FC = () => {
  useEffect(() => {
    // Load Tally widget script
    const script = document.createElement("script");
    script.src = "https://tally.so/widgets/embed.js";
    script.async = true;
    document.head.appendChild(script);

    // Initialize Tally embeds when script is loaded
    script.onload = () => {
      // @ts-ignore - Tally is loaded via script
      if (window.Tally) {
        // @ts-ignore
        window.Tally.loadEmbeds();
      }
    };

    return () => {
      // Cleanup script on component unmount
      document.head.removeChild(script);
    };
  }, []);

  return (
    <Paper elevation={0} sx={tallyFormPanelStyles.container}>
      <Box sx={tallyFormPanelStyles.formContainer}>
        <iframe
          data-tally-src={MATERIOM_AI_SOURCES_TALLY_FORM_URL}
          loading="lazy"
          color={theme.palette.text.primary}
          width="100%"
          height="100%"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
          title="materiom-ai-sources-tally"
        />
      </Box>
    </Paper>
  );
};

export default TallyFormPanel;
